import styled, { css } from 'styled-components';
import { layout } from 'src/components/base';
import { Link } from 'react-router-dom';
import { FontWeight } from '@prisjakt/ui/text/variants';

export const MembershipLink = styled(Link)`
  display: flex;
  align-items: center;
  font-size: ${layout.measurements.fontSizeNormal};
  font-weight: ${FontWeight.HEAVIER};
  color: ${p => p.theme.text.callToAction};

  svg {
    margin-left: ${layout.measurements.spacing025};

    > path {
      fill: ${p => p.theme.text.callToAction};
    }

    :hover {
      color: ${p => p.theme.text.callToActionHover};

      svg > path {
        fill: ${p => p.theme.text.callToActionHover};
      }
    }
  }
`;

export const MembershipInfoText = styled.span(
  props => css`
    color: ${props.theme.text.secondary};
    margin-right: ${layout.measurements.spacing050};
  `
);

export const InfoLinkWrapper = styled.div`
  display: flex;
  align-items: center;
`;
